import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationUpdateUserCompanyInformationArgs,
  BackendUser,
} from 'src/types/backend';

const MUTATION = gql`
  mutation UpdateUserCompanyInformation(
    $userRoles: [String!]
    $companySize: String
    $companyWebsite: String
  ) {
    updateUserCompanyInformation(
      userRoles: $userRoles
      companySize: $companySize
      companyWebsite: $companyWebsite
    ) {
      id
      segment
    }
  }
`;

type Variables = BackendMutationUpdateUserCompanyInformationArgs;
type Result = Pick<BackendUser, 'id' | 'segment'>;

export const updateUserCompanyInformation = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
